import React, { useRef } from "react";
import { Form } from "antd";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const FormEditor = ({ label, name, rules, placeholder, ...rest }) => {
  const quillRef = useRef(null);
  return (
    <Form.Item
      label={label}
      name={name}
      rules={rules}
      {...rest}
      className="custom-editor"
    >
      <ReactQuill
        ref={quillRef}
        theme="snow"
        placeholder={placeholder}
        modules={{
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            ["blockquote", "code-block"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }],
            ["link", "clean"],
          ],
        }}
      />
    </Form.Item>
  );
};
export default FormEditor;
